export default __webpack_public_path__ + "static/media/007-psychology.7ac02037.svg";